import React from "react";
import { Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ClaimUnsuccessful = ({
  IMAGE_BASE_URL,
  digitalorderDetailsData,
}) => {
  return (
    <Box sx={{ textAlign: "center", py: 4 }}>
      {/* Circular Image with Error Badge */}
      <Box sx={{ position: "relative", display: "inline-block", mb: 3 }}>
        {/* Outer Circle */}
        <Box
          sx={{
            width: { xs: 140, sm: 160 },
            height: { xs: 140, sm: 160 },
            borderRadius: "50%",
            border: "6px solid #E8A1A1", // light red border
            backgroundColor: "#F3F4F6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          {/* Inner Image */}
          <img
            src={`${IMAGE_BASE_URL}/${digitalorderDetailsData?.variantImageUrl}`}
            alt="Subscription"
            style={{
              width: "70%",
              height: "70%",
              objectFit: "contain",
            }}
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/120";
            }}
          />
        </Box>

        {/* Red Close Badge */}
        <Box
          sx={{
            position: "absolute",
            bottom: 8,
            right: 8,
            width: 44,
            height: 44,
            borderRadius: "50%",
            backgroundColor: "#D32F2F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "4px solid #ffffff",
            boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
          }}
        >
          <CloseIcon sx={{ color: "#ffffff", fontSize: 26 }} />
        </Box>
      </Box>

      {/* Title */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          color: "#1f2937",
          mb: 1,
        }}
      >
        Claim Unsuccessful
      </Typography>

      {/* Subtitle */}
      <Typography
        variant="body1"
        sx={{
          color: "#4b5563",
          fontSize: { xs: "16px", sm: "18px" },
          maxWidth: 320,
          mx: "auto",
          lineHeight: 1.5,
        }}
      >
        Don’t Worry – Your Payment Is Safe.
        <br />
        You’ll Receive A Refund Within 24 Hours.
      </Typography>
    </Box>
  );
};

export default ClaimUnsuccessful;